"use client";

import { DynamicIcon, Tabs } from "@template/components";
import DomainNameSearch, {
  DomainNameSearchProps,
} from "@template/blocks/domain/DomainNameSearchTabs/DomainNameSearch";
import { TTab } from "@template/components/Tabs";
import DomainNameSearchBulk, {
  DomainNameSearchBulkProps,
} from "@template/blocks/domain/DomainNameSearchTabs/DomainNameSearchBulk";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";
import * as S from "./styles.ts";

const DomainNameSearchTabs = ({
  search,
  searchBulk,
  defaultSelected = "search",
  altStyling,
}: {
  search: DomainNameSearchProps & {
    label: TTab["label"] & {
      icon?: string;
    };
    href?: string;
  };
  searchBulk: DomainNameSearchBulkProps & {
    label: TTab["label"] & {
      icon?: string;
    };
    href?: string;
  };
  defaultSelected?: string;
  altStyling?: boolean;
}) => {
  const tabs: TTab[] = [
    {
      label: {
        ...search.label,
        startContent: search.label.icon ? (
          <DynamicIcon name={search.label.icon} />
        ) : (
          search.label.startContent
        ),
      },
      key: "search",
      content: <DomainNameSearch {...search} />,
      href: search.href,
    },
    {
      label: {
        ...searchBulk.label,
        startContent: searchBulk.label.icon ? (
          <DynamicIcon name={searchBulk.label.icon} />
        ) : (
          searchBulk.label.startContent
        ),
      },
      key: "bulk",
      content: <DomainNameSearchBulk {...searchBulk} />,
      href: searchBulk.href,
    },
  ];

  return (
    <S.Wrapper $altStyling={altStyling}>
      {altStyling && (
        <ArchStandaloneSectionComponent
          color="white"
          style={{
            position: "absolute",
            top: 100,
          }}
        />
      )}
      <Tabs
        defaultSelected={defaultSelected}
        tabs={tabs}
      />
    </S.Wrapper>
  );
};

export default DomainNameSearchTabs;
